import { render, staticRenderFns } from "./CongrateDialog.vue?vue&type=template&id=1fe927bb&scoped=true"
import script from "./CongrateDialog.vue?vue&type=script&lang=js"
export * from "./CongrateDialog.vue?vue&type=script&lang=js"
import style0 from "./CongrateDialog.vue?vue&type=style&index=0&id=1fe927bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe927bb",
  null
  
)

export default component.exports